<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-footer-total="true"
                        :type-report-not-sale="true"
                        :show-button-new="false"
                        :show-button-export="true"
                        :reload-table-server.sync="reloadTableServer">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
<!--                            <x-button-icon icon="fa-light fa-ellipsis-vertical"-->
<!--                                           class="x-button-icon-small"-->
<!--                                           @click="clickDialogInformation(row.id)"></x-button-icon>--> 
                        </template>
                        <template v-else-if="col['name'] === 'date_of_issue'">
                            {{ row.date_of_issue }}<br/>{{ row.time_of_issue }}
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>
    </div>
</template>

<script>

import XTableServer from "../../../../components/Form/XTableServer.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";

export default {
    name: 'ReportItemNotSale',
    components: {
        XButtonIcon, XButtonDownload, XButtonPrimary, XTableServer
    },
    data() {
        return {
            title: 'Reporte de productos sin rotación',
            resource: 'items/report_items_not_sale',
            recordId: null,
            showDialogForm: false,
            showDialogInformation: false,
            reloadTableServer: false,
        }
    },
    methods: {
    }
}
</script>
